import { Loader2 } from 'lucide-react';

export function LoadingState({ message = 'Cargando datos...' }) {
  return (
    <div 
      className="flex flex-col items-center justify-center py-12 gap-4"
      role="status"
      aria-live="polite"
    >
      <Loader2 
        className="h-8 w-8 animate-spin text-primary" 
        aria-hidden="true"
      />
      <p className="text-muted-foreground text-sm">{message}</p>
    </div>
  );
}

export function LoadingCard() {
  return (
    <div className="bg-card border border-border rounded-xl p-5 animate-pulse">
      <div className="h-4 bg-muted rounded w-3/4 mb-3"></div>
      <div className="h-8 bg-muted rounded w-1/2 mb-2"></div>
      <div className="h-3 bg-muted rounded w-full"></div>
    </div>
  );
}

export function LoadingList({ items = 3 }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: items }).map((_, i) => (
        <LoadingCard key={i} />
      ))}
    </div>
  );
}

export default LoadingState;
